/**
 * i18n dynamic loader
 */
class I18n {
    constructor() {
        this.currentLang = 'ko';
        this.translations = {};
    }

    async init(lang = 'ko') {
        this.currentLang = lang;
        await this.loadTranslations(lang);
    }

    async loadTranslations(lang) {
        try {
            // Try public root first (Vite best practice)
            let response = await fetch(`${lang}.json`);
            if (!response.ok) {
                // Fallback to assets folder
                response = await fetch(`assets/${lang}.json`);
            }
            if (!response.ok) {
                throw new Error(`Failed to load ${lang} translations`);
            }
            this.translations = await response.json();
        } catch (error) {
            console.error('i18n initialization error:', error);
            // Fallback to basic dictionary if fetch fails
            this.translations = {
                "processing": "처리 중",
                "please_wait": "잠시만 기다려주세요..."
            };
        }
    }

    t(key) {
        return this.translations[key] || key;
    }

    // Used to translate DOM elements with data-i18n attribute
    translateDOM() {
        const elements = document.querySelectorAll('[data-i18n]');
        elements.forEach(el => {
            const key = el.getAttribute('data-i18n');
            if (this.translations[key]) {
                el.textContent = this.translations[key];
            }
        });
    }
}

export const i18n = new I18n();
